function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useField, Field, ErrorMessage } from "formik";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Label from "./label";
import "./input.scss";
import { useState } from "react";
export var Input = function (_ref) {
  var id = _ref.id,
    name = _ref.name,
    label = _ref.label,
    validate = _ref.validate,
    className = _ref.className,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    _ref$isGroup = _ref.isGroup,
    isGroup = _ref$isGroup === void 0 ? false : _ref$isGroup,
    as = _ref.as,
    rest = _objectWithoutProperties(_ref, ["id", "name", "label", "validate", "className", "type", "isGroup", "as"]);
  /* eslint-disable no-unused-vars */
  var _useField = useField(name),
    _useField2 = _slicedToArray(_useField, 2),
    field = _useField2[0],
    meta = _useField2[1];
  var isInvalid = meta.error && meta.touched;
  var inputClasses = classNames('a-input', {
    'a-input--select': as === "select"
  }, {
    'a-input--error': isInvalid
  }, className);
  var _useState = useState(new Date()),
    _useState2 = _slicedToArray(_useState, 2),
    startDate = _useState2[0],
    setStartDate = _useState2[1];
  var _useState3 = useState(new Date()),
    _useState4 = _slicedToArray(_useState3, 2),
    startDateTime = _useState4[0],
    setStartDateTime = _useState4[1];
  var _useState5 = useState(new Date()),
    _useState6 = _slicedToArray(_useState5, 2),
    startTime = _useState6[0],
    setStartTime = _useState6[1]; // Since this just is a thin wrapper... we DoRY
  switch (type) {
    case "radio":
    case "checkbox":
      return /*#__PURE__*/React.createElement("div", {
        className: "a-input-wrapper"
      }, /*#__PURE__*/React.createElement(Field, _extends({
        name: name,
        validate: validate,
        type: type,
        id: id,
        className: inputClasses
      }, rest)), /*#__PURE__*/React.createElement(Label, {
        label: label,
        htmlFor: id,
        isInvalid: isInvalid
      }, !isGroup && /*#__PURE__*/React.createElement(ErrorMessage, {
        component: "div",
        name: name,
        className: "a-input__feedback"
      })));
    case "date":
      return /*#__PURE__*/React.createElement(DatePicker, {
        selected: startDate,
        onChange: function (val) {
          return setStartDate(val);
        }
      });
    case "datetime":
      return /*#__PURE__*/React.createElement(DatePicker, {
        selected: startDateTime,
        onChange: function (val) {
          return setStartDateTime(val);
        },
        showTimeSelect: true,
        timeFormat: "HH:mm",
        timeIntervals: 15,
        timeCaption: rest.timeCaption || "klokkeslett",
        dateFormat: "MMMM d, yyyy HH:mm"
      });
    case "time":
      return /*#__PURE__*/React.createElement(DatePicker, {
        selected: startTime,
        onChange: function (val) {
          return setStartTime(val);
        },
        showTimeSelect: true,
        timeFormat: "HH:mm",
        timeIntervals: 15,
        timeCaption: rest.timeCaption || "klokkeslett",
        dateFormat: "HH:mm"
      });
    default:
      return /*#__PURE__*/React.createElement(Label, {
        label: label,
        htmlFor: id,
        isInvalid: isInvalid
      }, /*#__PURE__*/React.createElement(Field, _extends({
        name: name,
        validate: validate,
        type: type,
        id: id,
        className: inputClasses,
        as: as
      }, rest)), /*#__PURE__*/React.createElement(ErrorMessage, {
        component: "div",
        name: name,
        className: "a-input__feedback"
      }));
  }
};
Input.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired
};
export default Input;